import { render, staticRenderFns } from "./InflowChannelAnalytics.vue?vue&type=template&id=1198efef"
import script from "./InflowChannelAnalytics.vue?vue&type=script&lang=js"
export * from "./InflowChannelAnalytics.vue?vue&type=script&lang=js"
import style0 from "./InflowChannelAnalytics.vue?vue&type=style&index=0&id=1198efef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports